<template>
    <div v-if="componentData" class="wrapper TrustedBy">

        <div class="intro__caption margin-bottom-l">
            Trusted by
        </div>
        <div class="trusted-by__logos grid five">
            <component 
                :is="block.url ? 'a' : 'div'"
                v-for="(block, index) in componentData.blocks" 
                :key="index"
                :href="block.url || undefined"
                :target="block.url ? '_blank' : undefined"
                :rel="block.url ? 'noopener noreferrer' : undefined"
                :aria-label="block.url ? `Visit ${block.name} website` : undefined"
                class="trusted-by__logo"
                data-gsap="fadeIn"
                :data-gsap-delay="0.2 + index * 0.1">
                <figure v-if="block.logo">    
                    <img 
                        :src="block.logo.data.attributes.url"
                        :alt="block.logo.data.attributes.alternativeText || block.name"
                        class="trusted-by-logo"
                        loading="lazy"
                    />
                </figure>
            </component>
        </div>
    </div>
</template>

<script lang="ts">

import { defineComponent } from 'vue'

export default defineComponent({
    props:{
        componentData: {
            type: Object,
            required: false
        },
    },
    setup(props) {
        const homeurl: string = import.meta.env.VITE_API_URL;

        return {
            homeurl
        };
    }
})

</script>
